const partition = (array, predicate) => array.reduce((result, e, i) => {
    predicate(e, i, array) ? result[0].push(e) : result[1].push(e);
    return result;
}, [[], []]);
export { partition };
